<template>
  <div class="render">
    <div class="vacate">
      <el-form-item
        :label-width="itemRender.width"
        :label="itemRender.label"
        :required="itemRender.required ? true : false"
      >
        <div class="vacate-item">
          <span>关联应收</span>
          <el-input
            v-model="itemRender.value"
            placeholder="请选择(必填)"
          ></el-input>
        </div>
        <div class="vacate-item">
          <span>回款日期</span>
          <el-input
            v-model="itemRender.value"
            placeholder="请选择(必填)"
          ></el-input>
        </div>
        <div class="vacate-item">
          <span style="color: #a3a5a8">回款计划</span>
          <!-- <el-input
            v-model="itemRender.value"
            placeholder="请选择(必填)"
          ></el-input> -->
        </div>
        <div class="vacate-item">
          <span>计划日期</span>
          <el-input
            v-model="itemRender.value"
            placeholder="请选择(必填)"
          ></el-input>
        </div>
        <div class="vacate-item">
          <span>未回款(元)</span>
          <el-input
            v-model="itemRender.value"
            placeholder="请输入金额(必填)"
          ></el-input>
        </div>
        <div class="vacate-item">
          <span>本次回款(元)</span>
          <el-input
            v-model="itemRender.value"
            placeholder="请输入本次回款金额(必填)"
          ></el-input>
        </div>
        <div class="vacate-item vacate-item2">
          <i class="el-icon-plus"></i> 添加
        </div>
        <div class="vacate-item" v-if="itemRender.invoice">
          <span>电子发票</span>
          <el-input
            v-model="itemRender.value"
            :placeholder="itemRender.invoicechecked ? '必填' : ''"
          ></el-input>
        </div>
        <div class="vacate-item" v-if="itemRender.project">
          <span>项目</span>
          <el-input
            v-model="itemRender.value"
            :placeholder="itemRender.projectchecked ? '请输入(必填)' : '请输入'"
          ></el-input>
        </div>
        <div class="vacate-item" v-if="itemRender.customer">
          <span>客户</span>
          <el-input
            v-model="itemRender.value"
            :placeholder="
              itemRender.customerchecked ? '请输入(必填)' : '请输入'
            "
          ></el-input>
        </div>

        <div class="vacate-item" v-if="itemRender.timeDay">
          <span>附件</span>
          <el-input
            v-model="itemRender.value"
            :placeholder="itemRender.timeDaychecked ? '必填' : ''"
          ></el-input>
        </div>
        <div class="vacate-item" v-if="itemRender.remarks">
          <span>备注</span>
          <el-input
            v-model="itemRender.value"
            :placeholder="itemRender.remarkschecked ? '请输入(必填)' : '请输入'"
          ></el-input>
        </div>
      </el-form-item>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    itemRender: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
::v-deep .el-radio-group {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;
  .el-radio {
    margin-bottom: 12px;
  }
}
.vacate {
  .vacate-item {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    padding: 0 0 8px;
    border-bottom: 1px solid #dfe2e8;
    ::v-deep .el-input__inner {
      border: 0;
    }
    span {
      width: 115px;
    }
  }
  .vacate-item2 {
    background-color: #f7f9ff;
    display: block;
    text-align: center;
    color: #0089ff;
  }
}
.el-form-item {
  position: relative;
  .phone {
    position: absolute;
    right: 10px;
    top: 0px;
  }
  .phoneNumber {
    display: flex;
    align-items: center;
    border: 1px solid #dfe2e8;
    padding: 0 8px;
    ::v-deep .el-input__inner {
      border: 0;
    }
    span {
      padding-right: 8px;
      border-right: 1px solid #dfe2e8;
    }
  }
  .enclosure {
    display: flex;
    align-items: center;
    color: #999999;
    i {
      color: #5794f6;
      font-size: 18px;
      font-weight: bold;
      margin-right: 8px;
    }
  }
}
.money {
  .div {
    margin-top: 12px;
  }
}
</style>
